import React from "react";
import "../App.css";  // Assuming you have some custom CSS for styling

const ConfirmDeleteModal = ({ isOpen, onCancel, onConfirm, UserToDelete }) => {
  if (!isOpen) return null;  // Don't render modal if it's not open

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Are you sure you want to delete this user?</h2>
        <br></br>
        <h4>{UserToDelete.name}</h4>
        <h4>{UserToDelete.phone}</h4>
        <h4>{UserToDelete.email}</h4>
        <br></br>
        <div className="modal-buttons">

          <button className="cancel-button" onClick={onCancel}>Cancel</button>
          <button className="confirm-button" onClick={onConfirm}>Delete</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;